// src/components/checkout/OrderSummary.jsx
import React from "react";

const OrderSummary = ({ shop, deliveryFee }) => (
  <>
    {shop && (
      <div
        className="basket-header"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.75rem",
          marginBottom: "1rem",
          borderBottom: "1px solid #eee",
          paddingBottom: "0.75rem",
        }}
      >
        {shop.logo && (
          <img
            src={shop.logo}
            alt={shop.storeName}
            style={{
              width: 40,
              height: 40,
              borderRadius: 4,
              objectFit: "cover",
              backgroundColor: "#f5f5f5",
            }}
          />
        )}
        <h3 style={{ margin: 0 }}>{shop.storeName || "Twoje zamówienie"}</h3>
      </div>
    )}
  </>
);

export default OrderSummary;
